/* global ResizeObserver */
import { BaseCanvas } from './BaseCanvas.js'
/* global BaseCanvas */
import './BaseRenderer.scss'
import { debounce } from "./../../../js/debounce";

export class BaseRenderer extends BaseCanvas {
    constructor(params) {
        super(params)
        // this.$canvas = params?.canvas ?? document.body.querySelector('canvas') ?? document.createElement('canvas')
        // this.ctx = this.$canvas.getContext('2d')
        // this.canvasPixelRatio = 1
        
        this.$wrapper = this.$canvas.parentElement
        this.initResizeObserver()
    }
    setSize(width, height, updateStyle = true) {
        super.setSize(width, height, updateStyle)
    }
    initResizeObserver() {
        this.resizeObserverCallback = debounce((width, height) => {
            // console.log('[debounced] BaseRenderer::setSize()')
            this.setSize(width, height)
            const resizeEvent = new CustomEvent("canvas:resize")
            this.$wrapper.dispatchEvent(resizeEvent)
        }, 200)
        
        const resizeObserver = new ResizeObserver(() => this.resizeObserverCallback(this.$wrapper.clientWidth, this.$wrapper.clientHeight))
        
        resizeObserver.observe(this.$wrapper, {box: 'content-box'})
    }
    
}